<div fxLayoutAlign="center center" style="margin-top: 1em;">
  <div fxFlex="80" fxLayoutAlign="center center" fxLayoutGap="5%">
    <img src="/assets/i/ip.jpg" fxFlex="50">
    <div fxFlex="50">
      <h2>Intellectual Property Law</h2>
      <p>We are equipped to help individuals or businesses protect their copyrights, trademarks, and trade secrets. While intellectual property protection often goes hand in hand with contract negotiation, we can also help you register trademarks and copyrights, establish best practices for trade secret protection, and litigate to enforce your valuable rights.</p>
    </div>
  </div>
</div>
